import React from "react";
import "./styles/global.css";
import { useSelector } from "react-redux";
import Home from "./pages/Home";
import Cart from "./pages/Cart";

export default function App() {
  const { path } = useSelector((state) => state.router);

  return (
    <>
      {path === "home" && <Home />}
      {path === "cart" && <Cart />}
    </>
  );
}
